import React from 'react';
import { FaFacebookSquare } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaSquareXTwitter } from 'react-icons/fa6';
import { FaInstagramSquare } from 'react-icons/fa';
function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <footer>
      <div className="copyrgt">
        <div className="container">
          <center>
            <ul className="socialMediaLst">
              <li>
                <a
                  href="https://www.linkedin.com/in/anuvadini-ai/"
                  target="_blank"
                  rel="noreferrer">
                  <FaLinkedin />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/anuvadini"
                  target="_blank"
                  rel="noreferrer">
                  <FaSquareXTwitter />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61558139695563"
                  target="_blank"
                  rel="noreferrer">
                  <FaFacebookSquare />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/anuvadini_ai/"
                  target="_blank"
                  rel="noreferrer">
                  <FaInstagramSquare />
                </a>
              </li>
            </ul>
            <div className="footer-links">
              <ul className="trmsLnkList">
                <li>
                  <a
                    href="https://anuvadini.aicte-india.org/PrivacyPolicy"
                    title="Privacy Policy"
                    onClick={scrollToTop}
                    target="_blank"
                    rel="noreferrer">
                    Privacy Policy
                  </a>
                </li>
                |
                <li>
                  <a
                    href="https://anuvadini.aicte-india.org/tirmOfUse"
                    title="Term of Use"
                    onClick={scrollToTop}
                    target="_blank"
                    rel="noreferrer">
                    Term of Use
                  </a>
                </li>
                |
                <li>
                  <a
                    href="https://anuvadini.aicte-india.org/cookies-policy"
                    title="Cookie Policy"
                    onClick={scrollToTop}
                    target="_blank"
                    rel="noreferrer">
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
            <br />
            <p>
              © 2024 All rights reserved, Anuvadini AI, Ministry of Education,
              Government of India
            </p>
          </center>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
